<template>
  <div>
    <v-combobox
      v-if="$attrs.combobox"
      ref="combobox"
      v-model="maintenanceState.selectedItem"
      :items="maintenanceState.data"
      item-text="part_id_description"
      item-value="id"
      dense
      clearable
      class="font-weight-medium text-body-1"
      :loading="maintenanceState.isBusy"
      :rules="prepRules()"
      @change="onChange"
    >
      <template v-slot:label>
        <v-icon
          v-if="$attrs.required"
          class="required-icon"
          x-small
        >
          mdi-asterisk
        </v-icon>
        {{ $attrs.label }}
      </template>
    </v-combobox>
    <v-text-field
      v-else
      v-model="internalValue.part_id"
      :label="$attrs.label"
      clearable
      class="font-weight-medium text-body-1"
      @blur="onBlur(internalValue)"
    />
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Part',

    props: {
      value: {
        type: Object,
        default: null,
      },
    },

    data () {
      return {
        internalValue: this.value,
        hold_vendor_id: null,
        hold_part_id: null,
      }
    },

    computed: {
      ...mapGetters('app', [
        'getDataById',
      ]),
      appRules: get('app/rules'),
      displayAsSingular: get('part/displayAsSingular'),
      maintenanceState: get('part/parts'),
    },

    watch: {
      internalValue: {
        handler (val) {
          if (val.vendor_id !== this.hold_vendor_id) {
            this.hold_vendor_id = val.vendor_id
            this.retrieveParts(val.vendor_id)
          }

          this.$emit('input', this.internalValue)
        },
        deep: true,
      },
      value: {
        handler (val, oldVal) {
          // if (val.part_id === this.hold_part_id) return

          this.internalValue = val
          this.load()
        },
        deep: true,
      },
    },

    created () {
      this.unsubscribe = this.$store.subscribe((mutation) => {
        switch (mutation.type) {
          case 'part/push2Data':
            this.hold_part_id = `${this.internalValue.part_id}`
            this.setPart()
            break
        }
      })
    },

    beforeDestroy () {
      this.unsubscribe()
    },

    mounted () {
      this.initialize()
      this.load()
    },

    methods: {
      setPart () {
        // HACK! to get the v-model set after the options have been loaded
        this.internalValue.part_id = null
        this.internalValue.part_id = this.hold_part_id
      },

      retrieveParts (vendorId) {
        this.$store.dispatch('part/retrieve', { vendor_id: vendorId })
      },

      initialize () {
        if (this.internalValue && this.internalValue.vendor_id) {
          this.retrieveParts(this.internalValue.vendor_id)
        } else {
          this.$store.dispatch('part/setEmpty')
        }
      },

      load () {
        const selectedItem = this.getDataById(this.maintenanceState.data, this.internalValue.part_id)
        if (selectedItem && selectedItem.length > 0) {
          this.maintenanceState.selectedItem = selectedItem[0]
        } else {
          this.maintenanceState.selectedItem = null
        }
      },

      emitChange (dataItem) {
        this.$nextTick(() => {
          this.$emit('change', dataItem)
        })
      },

      prepareToUpdate (dataItem) {
        if (!dataItem.updated) {
          const originalData = this.getDataById(this.$attrs.originalData, dataItem.id)
          if (originalData.length > 0) {
            if (dataItem.part_id !== originalData[0].part_id) {
              this.$store.dispatch('user/setStateAsUpdated', dataItem)
            }
          }
        }
        this.emitChange(dataItem)
      },

      onChange (dataItem) {
        if (dataItem) {
          this.internalValue.part_id = dataItem.part_id
          this.internalValue.part_description = dataItem.description
          this.prepareToUpdate(this.internalValue)
        } else {
          this.emitChange(dataItem)
        }
      },

      onBlur (dataItem) {
        this.prepareToUpdate(dataItem)
      },

      prepRules () {
        const rules = []

        if (this.$attrs.required && !this.$attrs.disabled) {
          rules.push(this.appRules.required)
        }
        rules.push(this.appRules.validOption(this.maintenanceState.selectedItem, this.maintenanceState.data, `${this.displayAsSingular} does not exist in the list.`))

        return rules
      },
    },
  }
</script>

<style lang="scss" scoped>
.required-icon {
  vertical-align: top;
  color: #dd0000;
}
</style>
